import React, { FC, useCallback, useState } from 'react';
import Request, { RequestType } from '../../../../../interfaces/api/Request';
import { Link, TextField } from '@material-ui/core';
import { createUseStyles } from '../../../../../theming';
import { Link as RouterLink } from 'react-router-dom';

const useStyles = createUseStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    color: '#3f51b5',
  },
  textfield: {
    width: 150,
  },
  ticketLink: {
    marginTop: '5px !important',
    fontSize: 12,
  },
  error: {
    marginTop: '5',
    color: '#f44336',
    fontSize: '.75rem',
  },
});

interface Props {
  updateIssueId: (requestId: string, issueId: string) => void;
  request: Request;
}

const TicketField: FC<Props> = ({ request, updateIssueId }) => {
  const classes = useStyles();

  const getIssueId = useCallback(() => {
    if (request.issueId) {
      return request.issueId || '';
    } else if (request.type === RequestType.Technical) {
      return request.suggestedIssueId || '';
    }

    return '';
  }, [request]);

  const [issueId, setIssueId] = useState<string>(getIssueId());
  const [error, setError] = useState<string>();
  const [, setLoading] = useState(false);

  const handleChangeIssueId = (event: any) => {
    const value = event.target.value;
    setIssueId(value || '');
  };

  const handleSaveNewIssueId = async () => {
    if (issueId !== request.issueId) {
      setError(undefined);

      try {
        setLoading(true);
        await updateIssueId(request.id, issueId || '');
        setLoading(false);
      } catch (e) {
        setError(e.message);
        setLoading(false);
      }
    }
  };

  return (
    <div className={classes.root}>
      <TextField
        className={classes.textfield}
        label='Numéro du ticket'
        variant='outlined'
        size='small'
        value={issueId}
        onChange={handleChangeIssueId}
        onBlur={handleSaveNewIssueId}
      />

      {request.issueId && (
        <Link className={classes.ticketLink} component={RouterLink} to={`/dashboard/tickets/${request.issueId}`}>
          Voir le ticket
        </Link>
      )}

      {error && <div className={classes.error}>{error}</div>}
    </div>
  );
};

export default TicketField;
